import axios from 'axios';

//  const baseUrl = "http://13.200.132.161/"
 const middleUlr="notification-service/v1/"
 const baseUrl = "https://devkongapi.playbinge.in/"

var headers={
    'X-AUTH-TOKEN': localStorage.getItem('token')
  };
const axiosInstance = axios.create({
  baseURL:baseUrl+middleUlr,
  headers: {
    'Content-Type': 'application/json',
    'X-AUTH-TOKEN': headers["X-AUTH-TOKEN"] 
  }
});

export default axiosInstance;
